module.exports = __webpack_public_path__ + "img/arrow_up_icon.7f16cddf.svg";